/**
 * Discriminates the kind of activity timeline event.
 */
export enum ActivityEventTypeEnum {
  CHANGE = 'change',
  RELATIONSHIP_CHANGE = 'relationship_change',
  STATUS_CHANGE = 'status_change',
  SNAPSHOT_ACTION = 'snapshot_action',
}
